// src/docs/api/groups/suprimentosEndpoints.ts
import type { ApiEndpoint } from "../apiDocsSchema";

export const standbyEndpoints: ApiEndpoint[] = [
  {
    group: "Standby",
    name: "Standby Suprimentos",
    method: "GET",
    path: "/departamentos/suprimentos/standby",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/cadastro, sendo essencial para registro do usuário e vinculo de suas respectivas apiKeys.",

    responseDetails:
      "Retorna o objeto completo do usuário criado, e o nome vinculado a respectiva apiKey.",

    description: "Cria um novo usuário no sistema e retorna o accessToken.",
    authRequired: false,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Standby",
    name: "Standby Comercial",
    method: "GET",
    path: "/departamentos/comercial/standby",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/cadastro, sendo essencial para registro do usuário e vinculo de suas respectivas apiKeys.",

    responseDetails:
      "Retorna o objeto completo do usuário criado, e o nome vinculado a respectiva apiKey.",

    description: "Cria um novo usuário no sistema e retorna o accessToken.",
    authRequired: false,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
  {
    group: "Standby",
    name: "Standby Coordenação",
    method: "GET",
    path: "/departamentos/coordenacao/standby",
    usageDescription:
      "Essa API é utilizada em https://${seudominio}.com/cadastro, sendo essencial para registro do usuário e vinculo de suas respectivas apiKeys.",

    responseDetails:
      "Retorna o objeto completo do usuário criado, e o nome vinculado a respectiva apiKey.",

    description: "Cria um novo usuário no sistema e retorna o accessToken.",
    authRequired: false,
    developed: false,
    params: [
      {
        name: "page",
        in: "query",
        type: "number",
        required: false,
        description: "Página de resultados (default = 1).",
      },
    ],
    playgroundDefaults: {
      query: { page: "1" },
    },
    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },

  // depois você vai colocando os outros endpoints de suprimentos aqui
];
